import './new-package-accommodation.scss';

import HeaderContent from "@shared/ui/header-content/header-content";
import { Button } from "primereact/button";
import { FormProvider } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";

import FormPackageAccommodation from "../form-package-accommodation/form-package-accommodation";
import { useNewPackageAccommodation } from './new-package-accommodation.hook';

export function NewPackageAccommodation() {  
  const {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  } = useNewPackageAccommodation();

  return (
    <div id="NewPackageAccommodation" className="package-accommodation">
      <HeaderContent
        title={<h1>New Package Accommodation</h1>}
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      >
        <Button
          className="w-full block"
          label="Save"
          disabled={isCreating}
          onClick={handleSubmit(handleValidate, handleValidateError)}
        ></Button>
      </HeaderContent>

      <div className="p-7">
        <FormProvider {...formMethod}>
          <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4">
            <FormPackageAccommodation />
          </section>
        </FormProvider>
      </div>
    </div>
  );
}

export default NewPackageAccommodation;